let API_SERVER_VAL = "";
switch (process.env.NODE_ENV) {
    case "development":
        API_SERVER_VAL = "http://127.0.0.1:90";
        break;
    case "production":
        API_SERVER_VAL = process.env.REACT_APP_API_SERVER;
        break;
    default:
        API_SERVER_VAL = "http://127.0.0.1:8000";
}


export const uploadFileService = async (fileData) =>{
    var response = await fetch(`${API_SERVER_VAL}/uploadDocument/`, {
        method: "POST",
        body: fileData,
    });
    
    return response;
}

export const checkEddRecordService = async (phoneNumber) =>{
    var response = await fetch(`${API_SERVER_VAL}/eddcustomersUuid/${phoneNumber}`);
    return response;
}

export const fetchCustomerByuuid = async (uuid) =>{
    var response  = await fetch(`${API_SERVER_VAL}/eddcustomersPhone/${uuid}`);
    return response;
}
